import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "bootstrap/dist/css/bootstrap.min.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import $ from "jquery";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useTranslation } from "react-i18next";
import "react-image-crop/dist/ReactCrop.css";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authenticatedRequest } from "../../../config/axios";
import { doctorCreateUser } from "../../../config/service";
import { checkEmailFormate, validateIsraeliID } from "../../../utils/function";
import ButtonSpinner from "../../common/buttonSpinner";
import "./DoctorCreateUser.css";

let resetData = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  clientGender: "",
  clientDOB: "",
};

const DoctorCreateUser = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const lang = localStorage.getItem("lang");
  const [value, setValue] = useState(null);
  const [formValue, setformValue] = useState({
    first_name: "",
    last_name: "",
    email: "",
    id: "",
    phone: "",
    clientGender: "",
    clientDOB: "",
  });
  const [apiData, setApiData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    id: "",
    phone: "",
    clientGender: "",
    clientDOB: "",
    isPassportNum: "",
  });

  const [errors, setErrors] = useState({});

  const [cleared, setCleared] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [isPassport, setIsPassport] = useState(false);
  const [isManualType, setIsManualType] = useState(false);
  const [diagonosisError, setDiagonosisError] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  React.useEffect(() => {
    if (cleared) {
      setValue(null);
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => { };
  }, [cleared]);

  const onDateChange = (value) => {
    if (value) {
      setValue(value);
      const isoDate = value.toISOString();
      // var today = new Date();
      // var birthDate = new Date(value);
      // var age_now = today.getFullYear() - birthDate.getFullYear();

      // var m = today.getMonth() - birthDate.getMonth();
      // if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      //   age_now--;
      // }
      setformValue({
        ...formValue,
        dob: isoDate,
        clientDOB: isoDate,
      });
    }
  };
  const getUserDataById = async (id, isManual) => {
    if (!id) return;

    try {
      const response = await authenticatedRequest({
        method: "get",
        url: `/doctor/getUserDataById/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { result, statusCode } = response.data;
      if (statusCode === 200 && result) {
        setIsManualType(false);
        setDisabledBtn(true);

        const isoDate = result?.dob || "";
        const parsedDate = moment(isoDate);
        setValue(parsedDate);

        let passportValue = "";
        if (result && Object.hasOwn(result, "passportNumber")) {
          setIsPassport(result?.passportNumber);
          passportValue = result?.passportNumber;
        }

        // Consolidated data for formValue and apiData
        const commonData = {
          first_name: result?.firstName || "",
          last_name: result?.lastName || "",
          email: result?.email || "",
          phone: result?.phone || "",
          clientGender: result?.gender || "",
          dob: isoDate,
          clientDOB: parsedDate,
        };

        setformValue({
          ...formValue,
          ...commonData,
          patient_street: result?.clientAddress?.street || "",
          patient_houseno: result?.clientAddress?.house || "",
          patient_city: result?.clientAddress?.city || "",
          patient_pincode: result?.clientAddress?.pincode || "",
          id: id,
        });
        setApiData({
          ...apiData,
          ...commonData,
          isPassportNum: passportValue,
          id: result.id,
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setDisabledBtn(false);
      if (isManual) {
        setformValue({
          ...formValue,
          id: id,
          dob: "",
          patient_street: "",
          patient_houseno: "",
          patient_city: "",
          patient_pincode: "",
        });
      } else {
        setformValue({
          id: id,
          ...resetData,
          patient_street: "",
          patient_houseno: "",
          patient_city: "",
          patient_pincode: "",
        });
        setValue(null);
      }
      setApiData({
        ...resetData,
        isPassportNum: "",
        id: "",
      });
    }
  };

  const handleGetData = (id, isManualType) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const timeout = setTimeout(() => {
      getUserDataById(id, isManualType);
    }, 700);

    setDebounceTimeout(timeout);
  };

  const handleValueReset = () => {
    if (!isManualType) {
      setformValue({
        id: formValue.id,
        ...resetData,
        patient_street: "",
        patient_houseno: "",
        patient_city: "",
        patient_pincode: "",
      });
      setValue(null);
      setApiData({
        ...resetData,
        isPassportNum: "",
        id: "",
      });
      setIsPassport(false);
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    let updatedValue = value;

    switch (name) {
      case "id":
        updatedValue = value.replace(/\s/g, "").toUpperCase();
        if (!isPassport && updatedValue.length > 9) {
          return;
        }

        if (isPassport) {
          handleGetData(updatedValue, isManualType);
        } else if (updatedValue.length === 9) {
          handleGetData(updatedValue, isManualType);
        }

        if (formValue.id) {
          if (updatedValue !== formValue.id) {
            handleValueReset();
          }
        }

        break;

      case "first_name":
        updatedValue = value.replace(/\s/g, "");
        break;

      case "passportNumber":
        setIsPassport(!isPassport);
        setformValue((prev) => ({ ...prev, [name]: checked }));
        break;

      case "phone":
        if (!/^[0-9+ -]*$/.test(value)) {
          return;
        }
        break;

      default:
        break;
    }
    if (name !== "id") {
      setIsManualType(true);
    }
    setformValue((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  let isValidate;

  const validate = () => {
    isValidate = true;
    if (!formValue.id) {
      isValidate = false;
      toast.error(t("Please enter id number"));
      return;
    }
    if (!isPassport) {
      const isValidId = validateIsraeliID(formValue.id);

      if (!isValidId) {
        isValidate = false;
        toast.error(t("The ID number you entered is invalid"));
        return;
      }
    }

    if (!isPassport && formValue.id.length < 9) {
      isValidate = false;
      toast.error(t("Please enter full ID number"));
    }
    if (!formValue.first_name) {
      isValidate = false;
      toast.error(t("Please enter first name"));
      return;
    }
    if (!formValue.last_name) {
      isValidate = false;
      toast.error(t("Please enter last name"));
      return;
    }
    if (formValue?.email) {
      const isEmailCorrect = checkEmailFormate(formValue?.email);
      if (!isEmailCorrect) {
        isValidate = false;
        toast.error("Please enter valid email");
        return;
      }
    }
    if (!formValue.phone) {
      isValidate = false;

      toast.error(t("Please enter mobile number"));
      return;
    }
    if (formValue.phone) {
      if (formValue.phone.length > 20) {
        isValidate = false;

        toast.error(t("Mobile number max length 20"));
        return;
      }
      if (
        !formValue.phone.startsWith("05") &&
        !formValue.phone.startsWith("+")
      ) {
        isValidate = false;
        toast.error("Phone number must start with 05 or +.");
        return;
      }
      const parsedNumber = phoneUtil.parse(formValue.phone, "IL");
      if (!phoneUtil.isPossibleNumber(parsedNumber)) {
        isValidate = false;
        toast.error("Invalid phone number format.");
        return;
      }
      try {
        const parsedNumber = phoneUtil.parse(formValue.phone, "IL");
        if (!phoneUtil.isValidNumber(parsedNumber)) {
          isValidate = false;
          toast.error("Invalid phone number.");
          return;
        }
      } catch (err) {
        isValidate = false;
        toast.error("Invalid phone number.");
        return;
      }
    }
    if (!value) {
      isValidate = false;
      toast.error(t("Please choose date of birth"));
      return;
    }
    if (!value._isValid) {
      isValidate = false;
      toast.error(t("Please fill correct date of birth"));
      return;
    }

    return isValidate;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      let element = document.querySelector(".red-border");
      if (element) {
        element?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
      setTimeout(() => {
        setErrors({});
      }, 20000);
    }
  }, [Object.keys(errors).length > 0]);

  const CustomToolTip = ({ id, children, title }) => (
    <OverlayTrigger
      // delay={{ hide: 40000 }}
      overlay={
        <Tooltip id={id} className="prescription-tooltip">
          {title}
        </Tooltip>
      }
    >
      <span className="tooltip-circle">{children}</span>
    </OverlayTrigger>
  );

  useEffect(() => {
    if (diagonosisError) {
      let element = document.querySelector(".error-color");
      if (element) {
        element?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
      setTimeout(() => {
        setDiagonosisError(false);
      }, 5000);
    }
  }, [diagonosisError]);

  $("#rsd__select-day option:first-child").text(t("Day"));
  $("#rsd__select-month option:first-child").text(t("Month"));
  $("#rsd__select-year option:first-child").text(t("Year"));

  const handleSubmit = async (e) => {
    e.preventDefault();
    // store the states in the form data

    const removeProperties = (obj, propsToRemove) => {
      const newObj = { ...obj };
      propsToRemove.forEach((prop) => delete newObj[prop]);
      return newObj;
    };

    // Exclude these properties from formValue
    const excludedProperties = [
      "patient_street",
      "patient_houseno",
      "patient_city",
      "patient_pincode",
    ];

    const updatedFormValue = removeProperties(formValue, excludedProperties);

    let data = {
      ...updatedFormValue,
      passportNumber: isPassport,
    };

    try {
      if (validate()) {
        setLoading(true);
        let clientdata = data;

        console.log("clientdata", clientdata);

        // make axios post request
        const response = await doctorCreateUser(clientdata);
        toast.success(t(response.data.msg));
        setLoading(false);
        navigate("/AdminDashboard");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="container">
      <div className="user-create-section">
        <Form>
          <div
            className={`${"confirmation-agree-section"} ${lang === "EN" ? "textleft" : "textright"
              }`}
          >
            <>
              <div className="doctorCreateUserTabContainer mt-4">
                <h2>{t("Create Client")}</h2>
              </div>

              <div className="confirmation-input-section createUserDocForm">
                <Form.Group className="form-group">
                  <Form.Label className={`id-label ${isPassport}`}>
                    {" "}
                    <p className={` ${isPassport ? "label-active" : ""}`}>
                      {" "}
                      {t("Id Number")}
                    </p>
                    <div
                      class={`slideThree ${apiData?.id ? "disable-check" : ""
                        }  ${isPassport} ${lang}`}
                      data-translation={
                        !isPassport ? t("Passport") : t("Id Number")
                      }
                      disabled={apiData?.id}
                    >
                      <input
                        type="checkbox"
                        value="None"
                        id="slideThree"
                        name="passportNumber"
                        checked={isPassport}
                        onChange={handleChange}
                        disabled={apiData?.id}
                      />
                      <label
                        for="slideThree"
                        style={{
                          cursor: apiData?.id ? "not-allowed" : "pointer",
                        }}
                      ></label>
                    </div>
                    <p className={`${!isPassport ? "label-active" : ""}`}>
                      {" "}
                      {t("Passport")}
                    </p>
                  </Form.Label>
                  <Form.Control
                    name="id"
                    type={isPassport ? t("text") : t("number")}
                    onChange={handleChange}
                    id="id"
                    placeholder={isPassport ? t("Passport") : t("Id Number")}
                    value={formValue.id}
                    maxLength={!isPassport ? 9 : undefined}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("First Name")} </Form.Label>
                  <Form.Control
                    name="first_name"
                    type="text"
                    onChange={handleChange}
                    id="first_name"
                    placeholder={t("First Name")}
                    value={formValue.first_name}
                    disabled={apiData?.first_name}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Last Name")}</Form.Label>
                  <Form.Control
                    name="last_name"
                    type="text"
                    onChange={handleChange}
                    id="last_name"
                    placeholder={t("Last Name")}
                    value={formValue.last_name}
                    disabled={apiData?.last_name}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Email")} </Form.Label>
                  <Form.Control
                    name="email"
                    type="text"
                    onChange={handleChange}
                    id="email"
                    placeholder={t("Email")}
                    value={formValue.email}
                    disabled={apiData?.email}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>
                    {" "}
                    {t("Phone Number")}{" "}
                    <CustomToolTip
                      title={t(
                        "An Israeli phone number should start with 05. For a foreign number, please start with + and enter the full number with the country code."
                      )}
                      id="phoneNumber"
                    >
                      {" "}
                      ?{" "}
                    </CustomToolTip>
                  </Form.Label>
                  <Form.Control
                    name="phone"
                    type="text"
                    onChange={handleChange}
                    id="phone"
                    className="phone_number"
                    placeholder={t("Phone Number")}
                    value={formValue.phone}
                    pattern="[+0-9 \-]+"
                    disabled={apiData?.phone}
                  />
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label> {t("Gender")}</Form.Label>
                  <div className="choose-gender-grid">
                    <Form.Check
                      type={"radio"}
                      label={t("Male")}
                      name="clientGender"
                      value="Male"
                      onChange={handleChange}
                      checked={formValue.clientGender === "Male"}
                      disabled={apiData?.clientGender}
                    />
                    <Form.Check
                      type={"radio"}
                      label={t("Female")}
                      name="clientGender"
                      value="Female"
                      onChange={handleChange}
                      checked={formValue.clientGender === "Female"}
                      disabled={apiData?.clientGender}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Date of Birth")} </Form.Label>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: () => setCleared(true),
                        },
                      }}
                      views={["year", "month", "day"]}
                      onChange={onDateChange}
                      value={value}
                      disableFuture
                      format="DD/MM/YYYY"
                      inputFormat="DD/MM/YYYY"
                      className="rx-dob"
                      // openTo="year"
                      disabled={apiData?.dob}
                    />
                  </LocalizationProvider>
                </Form.Group>
              </div>
            </>
            <div className="mt-4">
              <Button
                size="lg"
                className="submit_button"
                onClick={handleSubmit}
                disabled={loading || disabledBtn}
              >
                {loading ? (
                  <ButtonSpinner
                    visible={loading}
                    strokeColor="white"
                    strokeWidth="4"
                    width="36"
                  />
                ) : (
                  t("Create User")
                )}
              </Button>
            </div>
          </div>
        </Form>
      </div>
      </div>
    </>
  );
};

export default DoctorCreateUser;
